import { render, staticRenderFns } from "./ProductionConvenioChart.vue?vue&type=template&id=09cc6584&scoped=true&"
import script from "./ProductionConvenioChart.vue?vue&type=script&lang=js&"
export * from "./ProductionConvenioChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cc6584",
  null
  
)

export default component.exports